import { render, staticRenderFns } from "./FirmCreate.vue?vue&type=template&id=0148aad1"
import script from "./FirmCreate.vue?vue&type=script&lang=js"
export * from "./FirmCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports